import { styled } from "@mui/material/styles";
import { Link } from "@mui/material";
import ReactPlayer from "react-player";

import ResponsiveImage from "components/ResponsiveImage";
import Placeholder from "components/Placeholder";

export const Root = styled(Link)({
  position: "relative",
  zIndex: 0,
});

export const PlayerWrapper = styled("div")({
  position: "relative",
  paddingTop: "56.25%",
  zIndex: -500,
});

export const StyledReactPlayer = styled(ReactPlayer)({
  position: "absolute",
  zIndex: -1500,
  top: 0,
  left: 0,
  "& video": {
    objectFit: "cover",
  },
});

export const Overlay = styled("div")({
  background: "linear-gradient(180deg,rgba(0,0,0,0) 0,#000 100%)",
  width: "100%",
  height: "50%",
  position: "absolute",
  zIndex: 100,
  bottom: 0,
  left: 0,
  opacity: 0.5,
  pointerEvents: "none",
});

export const ImageName = styled(ResponsiveImage)({
  position: "absolute",
  zIndex: 100,
  left: 10,
  bottom: 0,
  width: "auto",
  height: "35%",
  pointerEvents: "none",
});

export const Poster = styled(ResponsiveImage)({
  zIndex: "100",
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0,
});

export const Duration = styled("span", {
  shouldForwardProp: (prop) => prop !== "isStatic",
})(({ theme, isStatic }) => ({
  position: "absolute",
  zIndex: 100,
  fontSize: 12,
  color: "#fff",
  right: 10,
  bottom: 10,
  pointerEvents: "none",
  ...(isStatic && {
    right: 15,
    bottom: 18,
    fontSize: 18,
  }),
  [theme.breakpoints.up("mobile")]: {
    right: 20,
    bottom: 15,
    ...(isStatic && {
      bottom: 13,
    }),
  },
  [theme.breakpoints.up("tablet")]: {
    right: 40,
    bottom: 30,
    fontSize: 18,
    ...(isStatic && {
      right: 9,
      bottom: 10,
      fontSize: 15,
    }),
  },
}));

export const ClipSkeleton = styled(Placeholder)({
  width: "inherit",
  height: "inherit",
});
